import Modal from "../Reusable/Modal";
import { Button } from "../Reusable/Button";
import DataUpLogo from "../../assets/images/DataUpLogoAuth.svg";
import manworking from "../../assets/images/manworking.svg";
import { useModal } from "../../context/ModalContext";

const ConfirmationModal: React.FC = () => {
  const { isConfirmationOpen, closeConfirmationModal, openLoginModal } =
    useModal();
  return (
    <Modal
      isOpen={isConfirmationOpen}
      onClose={closeConfirmationModal}
      className="w-full max-w-[90vw] md:w-[484px] max-h-[95vh] md:h-[391px] overflow-y-auto"
    >
      <div className="p-1">
        <div className="flex justify-center mb-4">
          <img
            src={DataUpLogo}
            alt="DatauplogoAuth"
            className="w-[135.55px] h-[32px]"
          />
        </div>

        <div className="flex justify-center mb-4">
          <img
            src={manworking}
            alt="DatauplogoAuth"
            className="w-[180px] sm:w-[222px] h-[135px] sm:h-[166.5px] object-contain"
          />
        </div>

        <h2 className="text-xl sm:text-2xl font-bold text-center dark:text-white leading-tight mb-1">
          Request has been submitted
        </h2>
        <p className="text-center text-sm text-gray-500 mb-4 dark:text-white px-2">
          An admin will get in touch with you with the next steps.
        </p>

        <Button
          onClick={() => {
            closeConfirmationModal();
            openLoginModal();
          }}
          bgColor="bg-white"
          className="flex-1 w-full border border-gray-300"
          borderRadius="rounded-lg"
        >
          Back to Sign in
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
